import { Component, OnInit } from '@angular/core';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { ActivatedRoute, Router } from '@angular/router';
import { KModalService } from 'ng-k-modal';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { AsbestosisOutlineExposureService } from 'src/app/services/asbestosis-outline-exposure.service';
import * as moment from 'moment';
import { KImage } from 'ng-k-utils';
import { KIconType } from 'ng-k-icon';
import { IkTableData, KTableGridService } from 'ng-k-data-visualization';
import { ClaimsService } from 'src/app/services/claims.service';
import { UrlService } from 'src/app/services/url.service';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';
@Component({
  selector: 'app-activity-listing',
  templateUrl: './activity-listing.component.html',
  styleUrls: ['./activity-listing.component.scss']
})
export class ActivityListingComponent implements OnInit {

  showStage1: boolean = true;
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  claimId = '';
  taskId = '';
  public currentActivityId: any = '';
  public currentEmployerData = [];
  public sampleData = [];
  public data: any = [];
  public tableData!: IkTableData;
  public maxSize = 8;
  public successText!: string;
  public displaySuccess: boolean = false;
  public timeout!: number;
  public customData: any;

  constructor(

    private router: Router,
    private route: ActivatedRoute,
    private modalService: KModalService,
    private loaderService: GlobalLoadingService,
    private asbestosisOutlineExposureService: AsbestosisOutlineExposureService,
    public kTableGridService: KTableGridService,
    private claimsService: ClaimsService,
    private _auth: OauthPlusService,
    private urlService: UrlService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (!this.isUrlEncoded(params['claimId'])) {
        this.claimId = decodeURIComponent(params['claimId']);
      } else {
        this.claimId = params['claimId'];
      }
  
      if (!this.isUrlEncoded(params['taskId'])) {
        this.taskId = decodeURIComponent(params['taskId']);
      } else {
        this.taskId = params['taskId'];
      }
    });

    this._auth.$whenUserLoaded.subscribe(data=> {
      if(data) {
        this.getActivityList();
        this.getWorkflowOverview(this.claimId);
        // this.addActivityFormValidation();
      }
    });
  }

  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        this.customData = {
          claimId : this.claimId,
          claimantName : result.data.meta.claimant.claimantName,
          medicalConditionLabel: 'Mesothelioma',
          medicalConditionValue: 'mesothelioma'
        }
      }
    },
    err => {
    });
  }

  public isUrlEncoded(str: string): boolean {
    try {
      return str !== decodeURIComponent(str);
    } catch (e) {
      return false;
    }
  }

  public addNewActivity() {
    this.router.navigate(['mesothelioma/exposure/outline-exposure-to-dust/addActivity/',this.claimId,this.taskId])
  }

  getTableData(event: any) {
    let actionType = (event.action);
    if (actionType === 'delete') {
      this.currentActivityId = event.data[0].label;
      // this.modalService.setIsOpen('deleteActivityModal', true);

      let text = "Delete activity? This cannot be undone.";
      if (confirm(text) == true) {
        text = "You pressed OK!";
        this.deleteActivity(this.currentActivityId)
      } else {
        text = "You canceled!";
      }
    } else 
    if (actionType === 'edit') {
      this.currentActivityId = event.data[0].label;
      this.router.navigate(['mesothelioma/exposure/outline-exposure-to-dust/editActivity/',this.claimId,this.taskId,this.currentActivityId])
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = this.claimId? this.claimId : null;
      requestParam.taskId = this.taskId? this.taskId : null;
      requestParam.actionName = 'exposure_item_by_id';
      requestParam.payload = {
        "id":event.data[0].label
      };
      this.currentActivityId = event.data[0].label;
      this.loaderService.startLoadingIndicator('getTableData');
      thisObj.asbestosisOutlineExposureService.getActivityList(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('getTableData');
          // console.log(result.data[0].task);
          this.currentEmployerData = result.data[0].employer;
          // console.log(this.currentEmployerData);
        }  
      },
      err => {
        console.log('err')
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('getTableData');
      }); 
    }
  }

  initiateTable(tableData: any) {
    this.sampleData = [];
    this.data = [];
      this.sampleData = tableData;
    
      if (this.sampleData.length > 0) {
        for (const data of this.sampleData) {
          const temp = [
            {
              label: data['_id'],
              isShow: false
            },
            {
              label: data['employer']['employer'],
            },
            {
              label: moment(new Date(data['startDate'])).format('DD/MM/YYYY') 
            },
            {
              label: moment(new Date(data['endDate'])).format('DD/MM/YYYY') 
            },
            {
              label: data['task']
            },
            {
              label: data['fiber']
            },
            {
              label: data['fml']
            },
            {
              label: data['twa']
            },
            {
              label: data['fmlPerMinute']
            },
            {
              label: data['exposedMm']
            },
            {
              label: data['distanceCorrection']
            },
            {
              label: data['days']
            },
            {
              label: data['dose']
            },
            {
              label: '',
              icons: [
                {
                  type: KIconType.fas,
                  name: 'edit',
                  action: 'edit',
                  tooltipText: 'Edit',
                  id: data['_id']
                },
                {
                  type: KIconType.fas,
                  name: 'trash',
                  action: 'delete',
                  tooltipText: 'Delete',
                  id: data['_id']
                }
              ],
              align: 'center'
            }
          ];
          this.data.push(temp);
        }
      } else {
        const temp = [
          {
            label: 'No data found.',
            colspan: 12
          },
        ];
        this.data.push(temp);
      }
      
      this.tableDataInitialisation();
  }

  async tableDataInitialisation() {
    this.tableData = {
      header: [
        {
          label: 'Employer',
        },
        {
          label: 'From Date',
        },
        {
          label: 'To Date',
        },
        {
          label: 'Task',
        },
        {
          label: 'Fibre',
        },
        {
          label: 'Fibre/ml',
        },
        {
          label: 'TWA',
        },
        {
          label: '10 f/ml min',
        },
        {
          label: 'mm',
        },
        {
          label: 'Distance Correction',
        },
        {
          label: 'Days',
        },
        {
          label: 'Dose',
        },
        {
          label: 'Action',
        }
      ],
      isStaticData: true,
      data: this.data,
      isTableResponsive: true,
      rowStripedColour: 'brand-main',
      isSearchTextFilter: false,
      checkboxConfig: {
        isShow: false,
        colour: 'dark-grey'
      }
    };
    if (this.sampleData.length > 0) {
      this.tableData.pagination = {
        maxSize: this.maxSize,
        totalRows: this.sampleData.length,
        align: 'end',
      }
    }
    if (this.tableData.isStaticData) {
      this.kTableGridService.pushData(this.tableData);
    }
  }

  // completeExposure() {
  //   this.getWorkflowFulfill(this.claimId);
  // }

  public getWorkflowFulfill(claimId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId? claimId : null;
    this.loaderService.startLoadingIndicator('getWorkflowFulfill');
    thisObj.claimsService.getWorkflowFulfill(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowFulfill');
        this.router.navigate(['/claimDetail/',(this.claimId)]);
      }
    }); 
  }

  public getActivityList() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.urlService.fullyDecodeURI(this.claimId) : null;
    requestParam.taskId = this.taskId? this.urlService.fullyDecodeURI(this.taskId) : null;
    requestParam.actionName = 'exposure_full_list';
    requestParam.payload = {};
    this.loaderService.startLoadingIndicator('getActivityList');
    thisObj.asbestosisOutlineExposureService.getActivityList(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.initiateTable(result.data);
        this.loaderService.stopLoadingIndicator('getActivityList');
      }  
    },
    err => {
      console.log('err')
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getActivityList');
    }); 
  }

  deleteActivity(currentActivityId: any) {
    this.loaderService.startLoadingIndicator('deleteActivity');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.claimId : null;
    requestParam.taskId = this.taskId? this.taskId : null;
    requestParam.actionName = 'delete_exposure';
    requestParam.payload = {
      "id" : currentActivityId
    }

    thisObj.claimsService.postWorkflowActivity(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('deleteActivity');
        this.successText = 'Deleted activity';
        this.showMessage('success', 2000);
        this.modalService.setIsOpen('deleteActivityModal',false);
        setTimeout(() => {
          this.reloadCurrentRoute();
        },1000);
      }
    },
    err => {
      console.log('err')
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('deleteActivity');
    }); 
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        let routeToMove = this.urlService.cleanUrl(currentUrl);
        this.router.navigate(routeToMove);
    });
}

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    if ( msgType === 'success' ) {
      this.displaySuccess = true;
    }
    if ( timeout ) {
      this.timeout = timeout;
    } else {
      this.timeout = 1;
    }
  }

  closeDeleteActivityModal() {
    this.modalService.setIsOpen('deleteActivityModal',false);
  }

  goToPage() {
    this.router.navigate(['/claimDetail/',this.claimId]);
  }
  }


